<template>
    <div>
        <div class="row no-gutters py-2 mb-3 border-bottom ml-3">
                <div class="col-sm-6 pr-3 " >
                <h4 class="atlhr-dashboard-title mt-10">Migrated Payroll History<span><a v-bind:href="$api_url">Dashboard</a> / Migrated Payroll History</span></h4>
            </div>                               
            </div>
    <div class="employee-tab-inner custom-card-body bg-wash no-shadow">
        <div class="company-form-container">
            <div class="row no-gutters py-2 mb-3 border-bottom card-header">
                
                
                <template  v-if="flg > 0"><div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"  @click="addNew()">Add New</div></template>
            </div>
                        
            <b-overlay :show="showoverlay_list" rounded="sm" class="p-3">
                <div class="mt-0 p-4 rounded-border" v-if="mphs.length > 0">    
                                                                
                    <div class="row border-bottom">
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            Fiscal Year
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            Basic Salary
                        </div>                    
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            Medical Allowance
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            House Rent
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            Conveyance
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            Other Taxable Income
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            Total Tax Paid
                        </div>
    
                        <div class="col-sm text-uppercase py-1 font-weight-bold text-right" v-if="flg > 0">    
                            Action                                
                        </div>
                    </div>
                
                    <div class="row border-bottom py-2" v-for="mph in mphs" :key="mph.id">
                        
                        
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            {{mph.fiscal_year}}
                        </div>                    
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            &#2547 {{mph.basic_salary}}
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            &#2547 {{mph.medical_allowance}}
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            &#2547 {{mph.house_rent}}
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            &#2547 {{mph.conveyance}}
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            &#2547 {{mph.other_taxable_income}}
                        </div>
                        <div class="col-sm text-uppercase py-1 font-weight-bold">
                            &#2547 {{mph.total_tax_paid}}
                        </div>
    
    
    
                        <div class="col-sm   clearfix" v-if="flg > 0">                                
                            <b-button-toolbar class="float-right" v-if="mph.flg == 1">
                                <b-button-group class="mr-1">
                                    <b-button title="Edit MPH" @click="editMph(mph.id)">
                                        <b-icon icon="wrench" aria-hidden="true" ></b-icon>
                                    </b-button>
                                    <b-button title="Delete MPH" @click="deleteMph(mph.id)">
                                        <b-icon icon="trash" aria-hidden="true"></b-icon>
                                    </b-button>
                                </b-button-group>
                            </b-button-toolbar>
                            <div class="text-center float-right mr-4" v-else title="This entry can't be edited or deleted since a payrun has been approved after this was listed." v-b-tooltip placement="right">
                                <b-icon icon="info-circle"></b-icon>
                            </div>
                        </div>
                    </div>                        
                </div>
                <div class=" p-4" v-else>
                    No Migrated Payroll History Found!
                </div>
            </b-overlay>
    
            <b-modal id="bv-modal-example" size="lg" hide-footer title="Migrated Payroll History Details">
                <b-form @submit.stop.prevent="onSubmit">                    
                    <div class="clearfix">
                        
                        <div class="col-md-6 float-left">                           
                            
                            <input type="hidden" v-model="fdata.id" name="id">
                            <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year">
                                <b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>
                            </b-form-group>
                            
                            <b-form-group id="basic_salary-group" label="Basic Salary" class="required-field" label-for="basic_salary">
                                <b-form-input id="basic_salary" name="basic_salary" v-model="fdata.basic_salary" v-validate="{ required: true , numeric:true , min: 3 }" :state="validateState('basic_salary')" aria-describedby="basic_salary-feedback" data-vv-as="Basic Salary"></b-form-input>
                                <b-form-invalid-feedback id="basic_salary-feedback">{{ veeErrors.first('basic_salary') }}</b-form-invalid-feedback>
                            </b-form-group>
    
                            <b-form-group id="medical_allowance-group" label="Medical Allowance" class="required-field" label-for="medical_allowance">
                                <b-form-input id="medical_allowance" name="medical_allowance" v-model="fdata.medical_allowance" v-validate="{ required: true , numeric:true }" :state="validateState('medical_allowance')" aria-describedby="medical_allowance-feedback" data-vv-as="Medical Allowance"></b-form-input>
                                <b-form-invalid-feedback id="medical_allowance-feedback">{{ veeErrors.first('medical_allowance') }}</b-form-invalid-feedback>
                            </b-form-group>
    
    
                            <b-form-group id="house_rent-group" label="House Rent" class="required-field" label-for="house_rent">
                                <b-form-input id="house_rent" name="house_rent" v-model="fdata.house_rent" v-validate="{ required: true , numeric:true }" :state="validateState('house_rent')" aria-describedby="house_rent-feedback" data-vv-as="House Rent"></b-form-input>
                                <b-form-invalid-feedback id="house_rent-feedback">{{ veeErrors.first('house_rent') }}</b-form-invalid-feedback>
                            </b-form-group>
    
    
                            <b-form-group id="conveyance-group" label="Conveyance" class="required-field" label-for="conveyance">
                                <b-form-input id="conveyance" name="conveyance" v-model="fdata.conveyance" v-validate="{ required: true , numeric:true }" :state="validateState('conveyance')" aria-describedby="conveyance-feedback" data-vv-as="Conveyance"></b-form-input>
                                <b-form-invalid-feedback id="conveyance-feedback">{{ veeErrors.first('conveyance') }}</b-form-invalid-feedback>
                            </b-form-group>
    
    
                            <b-form-group id="other_taxable_income-group" label="Other Taxable Income" class="required-field" label-for="other_taxable_income">
                                <b-form-input id="other_taxable_income" name="other_taxable_income" v-model="fdata.other_taxable_income" v-validate="{ required: true , numeric:true }" :state="validateState('other_taxable_income')" aria-describedby="other_taxable_income-feedback" data-vv-as="Other Taxable Income"></b-form-input>
                                <b-form-invalid-feedback id="other_taxable_income-feedback">{{ veeErrors.first('other_taxable_income') }}</b-form-invalid-feedback>
                            </b-form-group>
                            
    
                            <b-form-group id="total_tax_paid-group" label="Total Tax Paid" class="required-field" label-for="total_tax_paid">
                                <b-form-input id="total_tax_paid" name="total_tax_paid" v-model="fdata.total_tax_paid" v-validate="{ required: true , decimal:2 }" :state="validateState('total_tax_paid')" aria-describedby="total_tax_paid-feedback" data-vv-as="Total Tax Paid"></b-form-input>
                                <b-form-invalid-feedback id="total_tax_paid-feedback">{{ veeErrors.first('total_tax_paid') }}</b-form-invalid-feedback>
                            </b-form-group>
    
                        </div>                            
                    </div>
    
                    <div class="mt-4 ml-4 mb-4 clearfix">
                        <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" type="submit" variant="primary">Submit</b-button>
                        <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" variant="primary" @click="resetForm()">Reset</b-button>
                    </div>
    
                </b-form>
            </b-modal>
                        
        </div>
    </div>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            
            //console.log(this.employee_id);  
        },
        props: ['flg'],
        data(){            
            
            return {                
                itabIndex : 0,
                fiscal_year : this.getCurrentFinancialYear(),
                
                mphs : [], 
                      
                successmsg:null,
                errormsg:[],
                fdata: {fiscal_year : this.getCurrentFinancialYear(), amount:null, id:null },
                     
                
            }
        },
        methods:{
            getMphs: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
               
                axios.get(this.$api_url+'/front/mph/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.mphs = response.data;
                    
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },   
            editMph:function(x)
            {        
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/front/mph/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.successmsg = null;
                    this.$bvModal.show('bv-modal-example');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                                
            },           
            
            deleteMph:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this MPH.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {                    
                    if(value)
                    {                        
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        
                        axios.post(this.$api_url+'/front/mph/delete', formData).then(function(response){
                            
                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg; 
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getMphs();                    
                            }
                            this.showoverlay_list = false;                            
                            
                        }.bind(this)).catch(function (error){ currentObj.showoverlay_list = false; currentObj.serverError(error);});   
                    }
                })
            }, 
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {fiscal_year: this.getCurrentFinancialYear() ,  id:null};
                
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-example');
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                                        
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/front/mph/save', formData, config)
                        .then(function (response) 
                        {                                                              
                            this.resetForm();
                            this.getMphs();
                            this.itabIndex = 1;                              

                            this.$bvToast.toast("Saved", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.$bvModal.hide('bv-modal-example');
                            
                        }.bind(this))
                        .catch(function (error) 
                        {
                            currentObj.serverError(error);
                            //currentObj.errormsg = error.response.data.errors;
                        });
                });
            },

        },
        created: function(){
            this.getMphs();
        }
    }
</script>